import { Injectable } from '@angular/core';
import {AppSettings} from "../../proyect.conf";
import {HttpClient} from "@angular/common/http";
import {AutenticacionService} from "./autenticacion.service";
import {map} from "rxjs/operators";
import {FlujoVentaPasosIntegracionesOcupaciones} from "../_models/flujo-venta-pasos-integraciones-ocupaciones";

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoIntegracionOcupacionService {

  private rutServicio = AppSettings.rutServiciosAPL + "/api/flujoVentaPasosIntegracionesOcupaciones";

  constructor(
    private httpClient: HttpClient,
    private authServicio: AutenticacionService
  ) {}

  listado() {
    return this.httpClient.get(this.rutServicio).pipe(map((res) => res as FlujoVentaPasosIntegracionesOcupaciones[]));
  }

  enabled() {
    return this.httpClient.get(this.rutServicio + "/enabled").pipe(map((res) => res as FlujoVentaPasosIntegracionesOcupaciones[]));
  }

  bulk(lista: FlujoVentaPasosIntegracionesOcupaciones[]) {
    return this.httpClient.post(this.rutServicio + "/bulk", lista).pipe(map((res) => res as FlujoVentaPasosIntegracionesOcupaciones[]));
  }
}
